import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute, RouterState, ActivatedRouteSnapshot, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';


import { ToastrService } from 'ngx-toastr';
import { MenuService } from './_components/menu/menu.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { RootLayout } from '../_theme/layouts';
import { pagesToggleService } from '../_theme/services/toggler.service';
import { IdleTimeParametersService } from '../_services/idle-time-parameters.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoginService } from './../_services/login.service';
import { HelpService } from '../_services/help.service';
import { ProfileService } from './_components/profile/profile.service';
import { Usuario } from '../_models/profile';
import { SecureService } from '../_services/secure.service';
import { CONFIG } from '../_config/config';


@Component({
  selector: "app-template",
  templateUrl: "./template.component.html",
  styleUrls: ["./template.component.scss"],
})
export class TemplateComponent extends RootLayout implements OnInit, OnDestroy {
  help: string = "";
  index1: number;
  info: Usuario;
  imgUrl: string = "";

  @ViewChild("mdStickUp") mdStickUp: ModalDirective;

  idleState = "Nó empezado.";
  loadingMenu = false;

  menuLinks: any;

  public nombre_completo: string;

  constructor(
    public toggler: pagesToggleService,
    public router: Router,
    private menuService: MenuService,
    private idleTimeParametersService: IdleTimeParametersService,
    private activatedRoute: ActivatedRoute,
    private helpService: HelpService,
    public profileService: ProfileService,
    private secureService: SecureService,
    private toastr: ToastrService,
    private loginService: LoginService,
    private config : CONFIG
  ) {
    super(toggler, router);
    this.info = new Usuario();
    this.loadingMenu = false;

    const nombre = this.secureService.encrypt("Remberto");
    console.log("Encriptado", nombre);
    // console.log('Desencriptado' , this.secureService.decrypt(nombre));

    this.profileService
      .onGetUser(sessionStorage.getItem("sysUserId"))
      .subscribe((res: any) => {
        this.nombre_completo = res.fullName;
        this.imgUrl = res.enlargedPhoto
          ? "data:image/png;base64," + res.enlargedPhoto
          : "";
      });
  }

  ngOnInit() {
    // Servicio de inactividad comentado por redimiento
    // this.idleTimeParametersService.inactiveTimmer( this.config.inactivity.seconds)
 
    document.title = `Labviewer`;
    this.changeLayout("menu-pin");
    // servicio de menu
    this.menuService.onGetMenu().subscribe(
      (menuItems) => {
        this.menuLinks = menuItems;
        this.loadingMenu = true;
      },
      (err) => {
        console.log(err);
        this.toastr.toastrConfig.positionClass = "toast-bottom-full-width";
        this.toastr.toastrConfig.timeOut = 5000;
        this.toastr.error(`Error:  ${err.error.message}`);
      }
    );
  }

  ngOnDestroy() {}
}
